import { configureStore, type Middleware } from '@reduxjs/toolkit';
import { createEpicMiddleware, type Epic } from 'redux-observable';

import { reduxBatch } from './state/utils/redux-batch';
import { getRootReducer } from './state/reducers';
import rootEpic from './state/epics';
import ChangeObserver from './state/middlewares/property-change-middleware';
import ValidationMiddleware from './state/middlewares/validation-middleware';
import DataPageMiddleware from './state/middlewares/datapage-middleware';
import PubSubMiddleware from './state/middlewares/pubsub-middleware';
import DataReferenceMiddleware from './state/middlewares/datareference-middleware';
import { setStore, getStore, resetStore } from './state/state-manager';

const epicMiddleware = createEpicMiddleware();

const configureAppStore = (translatedDXAPIResponse: any) => {
  if (getStore() !== null) {
    // Mashup case can call renderApp multiple times for "new" run-through
    // of the flow. renderApp calls configureStore which normally wants to
    // create the Store. However, in mashup case, we want to use the store
    // we already have but reset it to its initial state.
    // console.log(`store already exists! Call resetStore()`);
    resetStore();
    return;
  }

  const middlewares: Middleware[] = [
    ChangeObserver.propertyChangeMiddleware,
    ValidationMiddleware,
    DataPageMiddleware as Middleware,
    DataReferenceMiddleware,
    epicMiddleware,
    PubSubMiddleware as Middleware
  ];

  const store = configureStore({
    reducer: getRootReducer(translatedDXAPIResponse),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        thunk: false
      }).concat(middlewares),
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers().prepend(reduxBatch).concat(reduxBatch)
  });

  epicMiddleware.run(rootEpic as Epic);
  setStore(store);
};

export default configureAppStore;
